import {ReactElement} from 'react';
import {handleClickWord} from './types';

// export const highlight = (text: string, handler: handleClickWord): ReactElement<HTMLDivElement> => {
//   return <span>
//     {text.split(/[{}]{2}/).map((each, key) => {
//       if (key % 2 === 1) {
//         return <button
//           key={key}
//           onClick={() => handler(each)}
//           className='text-yellow-500'
//         >
//           {each}
//         </button>;
//       } else {
//         return <span key={key}>{each}</span>;
//       }
//     })}
//   </span>;
// };

export const highlight = (text: string, key: number, handler: handleClickWord, color: string, location?: string): ReactElement<HTMLDivElement> => (
  <span key={key}>
    {text.split(/[{}]{2}/).map((each, eachkey) => {
      const eachColor = location === each ? 'text-yellow-500' : color;
      return (eachkey % 2 === 1) ?
        <button
          key={eachkey}
          onClick={() => handler(each)}
          className={`btn-none ${eachColor}`}
        >
          {each}
        </button>:
        <span key={eachkey}>{each}</span>;
    })}
  </span>
);

// export const emParser = (rawText: string, key: number, handler: handleClickWord, keyword: string): ReactElement<HTMLSpanElement> => {
//   const regex = new RegExp(`(${keyword})`);
//   const text = rawText.replace(regex, '<em>$1</em>');
//   return (
//     <p key={key}>
//       {text
//           .replace(/<\/em><em>/g, '')
//           .split(/<\/?em>/)
//           .map((each: string, eachKey: number) => (
//             eachKey % 2 == 0 ?
//               <span key={eachKey}>{highlight(each, handler)}</span> :
//               <span key={eachKey} className='font-bold'>{highlight(each, handler)}</span>
//           ))
//       }
//     </p>
//   );
// };
